import React from "react";
import { getApi } from '../../api/endpoints';
import ListingPageComponent from '../../components/ListingPageComponent';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants';

const Index = () => {
    const defaultHeaderConfig = { disableSort: true };

    const headers = [
        {
            ...defaultHeaderConfig,
            label: 'ID',
            attr: 'id',
            disableSort: false
        },
        {
            ...defaultHeaderConfig,
            label: 'Name',
            attr: 'name',
        },
    ]

    return <>
        <ListingPageComponent
            key={PAGES.BikesListingPage.name}
            uiPage={uiManager.getUiPage(PAGES.BikesListingPage.name)}
            breadcrumbs={[{ label: 'Home', url: '/dashboard' }, { label: 'Bikes' }]}
            listingMutation={getApi('bikes')}
            className="bikes_listing-page"
            contentHeading="Bikes - Results"
            headers={headers}
            recordsKey="bikes"
            searchBy={['Name']}
        />
    </>
};

export default Index;
